"use strict";


//////////////////
// WEBPACK FOOTER
// ./~/react-dnd/dist/cjs/interfaces/monitors.js
// module id = 1808
// module chunks = 2